import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { LocationComponent } from '@rocksoft/places';

@Injectable()
export class LocationDeactivateGuard {
  constructor(private readonly router: Router) {}

  canDeactivate: CanDeactivateFn<LocationComponent> = (
    _component: LocationComponent,
    currentRoute: ActivatedRouteSnapshot,
    _currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ) => {
    const location = currentRoute.params.l;
    if (nextState.url === '/devices' && !!location) {
      void this.router.navigate(['/devices', location]);
    }
    return true;
  };
}
